//------------------------------------------------------------------------------
export class StringUtils {
  //----------------------------------------------------------------------------
  public static isNullOrEmpty(content: string): boolean {
    if (!content) {
      return true;
    }

    return (content.length === 0);
  }
}